
































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ShoppingCartProduct } from '@accounting/interfaces/shopping-cart';

@Component({
  name: 'bpc-shopping-cart-product-confirmation-modal',
})
export default class ShoppingCartProductConfirmationModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop(Object) readonly shoppingCartProduct: ShoppingCartProduct;

  onCloseModal() {
    this.$emit('close');
  }
}
